const bazarAf = {
  common: {
    brandLabel: 'برانډ',
    storeLabel: 'پلورنځی',
    unitCount: '',
  },
  search: {
    placeholders: [
      'د محصول نوم ولیکئ...',
      'د برانډ نوم ولیکئ...',
      'د پلورنځي نوم ولیکئ...',
      'د کتګوري نوم ولیکئ...'
    ]
  },
  sidebar: {
    categoriesTitle: 'کتګورۍ',
    storesTitle: 'پلورنځي',
  },
  store: {
    serviceAreaLabel: 'د خدمت ساحه',
    nationwide: 'ملکی',
    productCount: 'محصولات',
    productsOfSuffix: 'محصولات',
    description: 'لاندې د دې پلورنځي ټول شتون لرونکي محصولات دي. تاسو کولی شئ د کتګوري له مخې فلټر کړئ.',
  },
  buttons: {
    details: 'تفصیلات',
    addToCart: 'کارټ ته اضافه کړئ',
    clearFilters: 'فلټرونه پاک کړئ',
    close: 'تړل',
  },
  empty: {
    title: 'هیڅ محصول و نه موندل شو',
    subtitle: 'مهرباني وکړئ خپل فلټرونه تنظیم کړئ یا لټون وکړئ',
  },
};

export default bazarAf;
